export default __webpack_public_path__ + "static/start_2-40feab6aa73ebe3770bb90d896b07585.webp";